module.exports = __webpack_public_path__ + "static/media/course_analytics_empty_state.73011ed6.svg";